import { meshesForStep } from "../TS-VIEWER/Scene";

export const generateStepsForMeshes = function (lowerSteps, upperSteps) {
  const howMany = Math.max(lowerSteps, upperSteps);
  //we populate the array of arrays for meshes here too
  for (let i = 0; i < howMany; i++) {
    meshesForStep.push([]);
  }
};
